exports.paths = {
    ROOT: '/',
    ERROR404: '*'
}